import BlogLegacyContent from "components/BlogLegacyContent";
import type { Content } from "components/BlogLegacyContent";

interface BlogLegacyContentAdapterProps {
  blok: { content: Content };
}

const BlogLegacyContentAdapter = ({ blok: { content } }: BlogLegacyContentAdapterProps) => (
  <BlogLegacyContent content={content} extraStyles={{}} />
);

export default BlogLegacyContentAdapter;
